import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MAINTENANCE_CONFIG } from '../utils/constants';
import LoginEmail from '../pages/LoginEmail';
import LoginVerifyCode from '../pages/LoginVerifyCode';
import OnboardingPreferences from '../pages/OnboardingPreferences';
import OnboardingResume from '../pages/OnboardingResume';
import CandidateProfile from '../pages/CandidateProfile';
import Interview from '../pages/Interview';
import Dashboard from '../pages/Dashboard';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import CodingInterview from '../pages/CodingInterview';
import CodingChallenge from '../pages/CodingChallenge';
import GroupDiscussion from '../pages/GroupDiscussion';
import Settings from '../pages/Settings';
import Analytics from '../pages/Analytics';
import BuildInterview from '../pages/BuildInterview';
import BuildResume from '../pages/BuildResume';

const AppRoutes: React.FC = () => {
  return (
      <Routes>
        <Route path="/" element={<Navigate to="/candidate" replace />} />
        <Route
          path="/login"
          element={
            MAINTENANCE_CONFIG.ENABLED ? (
              <Navigate to="/candidate" replace />
            ) : (
              <ProtectedRoute requireAuth={false}>
                <LoginEmail />
              </ProtectedRoute>
            )
          }
        />
        <Route
          path="/login/verify-code"
          element={
            <ProtectedRoute requireAuth={false}>
              <LoginVerifyCode />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding/preferences"
          element={
            <ProtectedRoute requireOnboardingComplete={false}>
              <OnboardingPreferences />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding/resume"
          element={
            <ProtectedRoute requireOnboardingComplete={false}>
              <OnboardingResume />
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidate"
          element={
            <ProtectedRoute>
              <CandidateProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/interview"
          element={
            <ProtectedRoute>
              <Interview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/group-discussion"
          element={
            <ProtectedRoute>
              <GroupDiscussion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coding_challenge"
          element={
            <ProtectedRoute>
              <CodingChallenge />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coding-interview"
          element={
            <ProtectedRoute>
              <CodingInterview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/build-interview"
          element={
            <ProtectedRoute>
              <BuildInterview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/build-resume"
          element={
            <ProtectedRoute>
              <BuildResume />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/candidate" replace />} />
      </Routes>
  );
};

export default AppRoutes;
